<template>
  <div>
    <ul class="options">
      <li
        :class="{ 'options-label': true, active: index === activeIndex }"
        v-for="(tab, index) in tabs"
        :key="tab.name"
        @click="updateActiveIndex(index)"
        @keyDown="updateActiveIndex(index)">
        {{ tab.name }}
      </li>
    </ul>
    <div class="content">
      <component :key="activeIndex" :is="tabs[activeIndex].component" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'dx-tabs',
  props: {
    tabs: Array,
    // import { shallowRef } from 'vue';
    // [ { name: 'LABEL DA TAB', component: shallowRef(ComponentContent) } ]
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
  methods: {
    updateActiveIndex(index) {
      this.activeIndex = index;
    },
  },
};
</script>

<style scoped lang="scss">
  .options {
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: space-around;
    list-style-type: none;

    .options-label {
      cursor: pointer;
      text-align: center;
      width: 100%;
      font-size: var(--dx-text-size--md);
      padding: var(--dx-space-size--xs);
      margin: var(--dx-space-size--xs) 0;
      border-bottom: 4px solid transparent;

      &.active {
        border-color: var(--dx-color--blue-light);
      }
    }
  }
</style>
